import { Link } from 'react-router-dom'
import { TrendingUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { FEATURE_SCREENER_ENABLED } from '@/lib/featureFlags'
import { normalizeScreenerTicker } from '@/lib/screenerNavigation'

export function OpenInScreenerButton({ symbol }: { symbol: string }) {
  const ticker = normalizeScreenerTicker(symbol)
  if (!FEATURE_SCREENER_ENABLED || !ticker) return null

  return (
    <Button asChild variant="outline" size="sm">
      <Link to={`/screener?ticker=${encodeURIComponent(ticker)}`} aria-label={`Open ${ticker} in Screener`}>
        <TrendingUp className="h-3.5 w-3.5" />
        Screener
      </Link>
    </Button>
  )
}
